<template>
    <div>
        <b-card>
            <b-card-body>
                <p>
                    <label style="font-weight: bold">Total Quantity:</label
                    >&nbsp;{{ totalQty }}
                </p>

                <b-table
                    striped
                    hover
                    responsive
                    :items="inventoryList"
                    :fields="fields"
                >
                    <template #cell(id)="{ value }">
                        <b-button
                            size="sm"
                            @click="setUpdateForm(value)"
                            v-if="hasPermissionUpdate"
                            class="mr-2"
                            variant="primary"
                        >
                            Manage
                        </b-button>
                    </template>
                </b-table>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'MasterItems-itemInventory',
    mixins: [permissionsMixins],
    props: ['master_item_id'],
    data() {
        return {
            fields: [
                { key: 'id', label: 'ID' },
                {
                    key: 'location_section',
                    label: 'Sections',
                    formatter: value => `${value.location.name}, ${value.name}`,
                },
                { key: 'quantity_on_hand', label: 'Quantity' },
            ],
        }
    },
    computed: {
        warehouse_sections() {
            return this.$store.getters['locations/warehouse_sections'] || []
        },

        availableSections() {
            const { inventoryList } = this
            return this.warehouse_sections.filter(section => {
                return !inventoryList.some(
                    x => x.location_section_id === section.id
                )
            })
        },

        totalQty() {
            return this.inventoryList.reduce((_sum, item) => {
                _sum += item.quantity_on_hand
                return _sum
            }, 0)
        },
        inventoryList() {
            const items = this.$store.getters['masterItem/sections']
            console.log('inventoryList', items)
            return items
        },
    },

    methods: {},
}
</script>